import React from "react";
import OverviewLayout from "../components/OverviewLayout";
import ContactVisitSubmit from "../sections/contactsection/ContactVisitSubmit";
import HeroSection from "../sections/contactsection/HeroSection";
import CustomersSection from "../sections/homesection/CustomersSection";

const ContactPage = () => {
  return (
    <OverviewLayout>
      <HeroSection />
      <ContactVisitSubmit />
      <CustomersSection />
    </OverviewLayout>
  );
};

export default ContactPage;
